













import { Component, Prop, Vue } from 'vue-property-decorator'
import { LocationModel, Locations, Templates, UserState, TemplateModel, Messages, Appointments } from '../models'

@Component
export default class LocationPicker extends Vue {
  get availableTemplates() {
    const { activeId: activeLocationId } = Locations
    const templates = Templates.entitiesByLocationId[activeLocationId] || []

    if (templates.length === 1) {
      this.setTemplate(templates[0])
    }

    return templates
  }

  get templatesAreLoading() {
    return Templates.isLoading
  }

  setTemplate(template: TemplateModel) {
    Templates.SELECTED_TEMPLATE(template)
    Messages.RESET()
    Messages.GET_MESSAGES()
    Appointments.RESET()
    Appointments.GET_APPOINTMENTS()
  }
}
